import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { zipObject } from 'lodash-es';
const FALLBACK_LANG = 'zh';
export const defaultLocaleDetectOrder = [
    'querystring',
    'navigator',
    'localStorage',
    'cookie',
    'sessionStorage',
    'htmlTag',
    'path',
    'subdomain',
];
const genResources = ({ langList, langJsonList }) => {
    const langLen = langList.length;
    const jsonLen = langJsonList.length;
    if (langLen === 0 || jsonLen === 0)
        return undefined;
    else if (langLen !== jsonLen) {
        throw new Error('请保证需要支持的语言环境和相应json模块一一对应');
    }
    else {
        const jsonList = langJsonList.map(json => ({ translation: json }));
        return zipObject(langList, jsonList);
    }
};
// eslint-disable-next-line react-func/max-lines-per-function
export const i18nInit = ({ langList, langJsonList, querystring, localStorageKey, fallbackLng, keySeparator = '.', moreInitOptions = {}, moreDetectionOptions = {}, }) => {
    var _a;
    i18n
        .use(LanguageDetector)
        .use(initReactI18next)
        .init(Object.assign(Object.assign({}, moreInitOptions), { resources: genResources({ langList, langJsonList }), keySeparator, fallbackLng: fallbackLng || FALLBACK_LANG, detection: Object.assign(Object.assign({}, moreDetectionOptions), { order: (_a = moreDetectionOptions === null || moreDetectionOptions === void 0 ? void 0 : moreDetectionOptions.order) !== null && _a !== void 0 ? _a : defaultLocaleDetectOrder, lookupQuerystring: querystring, lookupLocalStorage: localStorageKey }) }));
};
export default i18n;
//# sourceMappingURL=i18n.js.map